export const Plus2Icon = ({
  className = '',
  borderColor = 'var(--color-shade)',
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 15 15"
      width="15"
      height="15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 2.75a1 1 0 0 0-2 0V6.5H2.75a1 1 0 0 0 0 2H6.5v3.75a1 1 0 0 0 2 0V8.5h3.75a1 1 0 0 0 0-2H8.5V2.75Z"
        fill="currentColor"
        stroke={borderColor}
      />
    </svg>
  )
}
